import vue from 'vue';
import VueI18n from "vue-i18n";
import zh from "@/common/locales/zh.json";
import en from "@/common/locales/en.json";
import Cookies from "js-cookie";

vue.use(VueI18n);

// 确保国际化资源文件已加载
const messages = {
  zh,
  en
};

const i18n = new VueI18n({
  locale: Cookies.get('userLanguage') || 'zh', // 优先使用用户选择的语言，默认中文
  messages
});

export default i18n;
